export const generateManufacturerCardDescription = (
  medication?: string,
) =>
  typeof medication === 'string' && medication.trim()
    ? `Manufacturer copay card - ${medication.trim()}`
    : 'Manufacturer copay card';
